export default function Logo() {
  return <h1>🌴 Plan Your Trip 💼 </h1>;
}
